import { OptionKey } from '@common-fe/common-fe';

import { ISpendLimitPeriodRemainingDto } from '@/dtos';

import { useGetSpendLimitPeriodsRemainingQuery } from '../queries';

const formatPeriodRemaining = (data: ISpendLimitPeriodRemainingDto) => ({
  remaining: data.remaining || 0,
  spendLimit: data.spend_limit || 0,
});

const useGetSpendLimitPeriodsRemaining = (id?: string, period?: OptionKey) => {
  const { data, isLoading, isError } = useGetSpendLimitPeriodsRemainingQuery(id, period);
  return {
    formattedData: data ? formatPeriodRemaining(data) : undefined,
    isLoading,
    isError,
  };
};

export default useGetSpendLimitPeriodsRemaining;
